import React from 'react';
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import { FontIcon, Modal } from '@fluentui/react';
import playImg from '../../../img/play.svg';
import styles from './VideoCarousel.module.css';
import Strings from '../../../translations/strings';
import { capitalizeString } from '../../../helpers/helpers';
import { Shimmer, IShimmerElement, ShimmerElementType } from '@fluentui/react';
import { IFeaturedVideosResponse } from '../VideoCarouselContainer/VideoCarouselContainer';
import { CommonDataConnection } from '@eway-crm/connector';

type TVideoCarouselProps = {
    commonDataConnection: CommonDataConnection;
    videos: IFeaturedVideosResponse | null;
    openedVideoIndex: number | null;
    openVideo: (index: number) => void;
    closeVideo: () => void;
};

const videosShimmerElements: IShimmerElement[] = [
    { type: ShimmerElementType.gap, width: 40 },
    { type: ShimmerElementType.line, height: 160 },
    { type: ShimmerElementType.gap, width: 16 },
    { type: ShimmerElementType.line, height: 160 },
    { type: ShimmerElementType.gap, width: 16 },
    { type: ShimmerElementType.line, height: 160 },
    { type: ShimmerElementType.gap, width: 16 },
    { type: ShimmerElementType.line, height: 160, width: 79 },
    { type: ShimmerElementType.gap, width: 40 },
];

export default class VideoCarousel extends React.Component<TVideoCarouselProps, {}> {
    render() {
        const lang = capitalizeString(Strings.getLanguage());
        return (
            <>
                <div className={styles.carouselWrap}>
                    <Shimmer isDataLoaded={!!this.props.videos} shimmerElements={videosShimmerElements}>
                        <Carousel
                            slidesPerPage={3.25}
                            arrows
                            arrowLeft={
                                <FontIcon iconName="ChevronLeft" className={`${styles.arrow} ${styles.arrowLeft}`} />
                            }
                            arrowRight={
                                <FontIcon iconName="ChevronRight" className={`${styles.arrow} ${styles.arrowRight}`} />
                            }
                            arrowLeftDisabled={
                                <div className={`${styles.arrowDisabled} ${styles.arrowLeftDisabled}`}>&shy;</div>
                            }
                            arrowRightDisabled={
                                <div className={`${styles.arrowDisabled} ${styles.arrowRightDisabled}`}>&shy;</div>
                            }
                            addArrowClickHandler
                            keepDirectionWhenDragging
                            breakpoints={{
                                1400: {
                                    slidesPerPage: 2.85,
                                },
                                1100: {
                                    slidesPerPage: 2.57,
                                },
                                1000: {
                                    slidesPerPage: 2.3,
                                },
                                900: {
                                    slidesPerPage: 1.9,
                                },
                                800: {
                                    slidesPerPage: 1.7,
                                },
                                700: {
                                    slidesPerPage: 1.6,
                                },
                                600: {
                                    slidesPerPage: 1.23,
                                },
                                400: {
                                    slidesPerPage: 1.15,
                                },
                            }}
                        >
                            {this.props.videos?.[lang]?.map((d, i) => (
                                <div key={'yt-carusel-img-' + i} className={styles.carouselItem}>
                                    <div className={styles.carouselItemInner} onClick={() => this.props.openVideo(i)}>
                                        <div className={styles.carouselItemImgAspectRatioBox}>
                                            <div className={styles.carouselItemImgAspectRatioFloater}>
                                                <img
                                                    src={d.ThumbnailUrl}
                                                    className={styles.carouselItemImg}
                                                    alt={d.Title}
                                                />
                                            </div>
                                            <div className={styles.carouselItemImgAspectRatioFloater}>
                                                <div className={styles.playBtnWrap}>
                                                    <span className={styles.playBtnSpan}></span>
                                                    <img src={playImg} className={styles.playImg} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Carousel>
                    </Shimmer>
                </div>
                {(!!this.props.openedVideoIndex || this.props.openedVideoIndex === 0) && (
                    <Modal isOpen={true} onDismiss={this.props.closeVideo} containerClassName={styles.modalContent}>
                        <iframe
                            id="ytplayer"
                            width="640"
                            height="360"
                            title={this.props.videos?.[lang]?.[this.props.openedVideoIndex].Title}
                            allowFullScreen
                            src={this.props.videos?.[lang]?.[this.props.openedVideoIndex].IframeUrl}
                            style={{ borderWidth: '0' }}
                        />
                    </Modal>
                )}
            </>
        );
    }
}
